const rankings = [
  { rank: 1, title: '长安如故', type: '国产古装', heat: '热度 9800', trend: 'up' },
  { rank: 2, title: '财阀家的小儿子', type: '韩剧悬疑', heat: '热度 9200', trend: 'up' },
  { rank: 3, title: '莲花楼', type: '国产武侠', heat: '热度 8700', trend: 'stable' },
  { rank: 4, title: '风骚律师', type: '美剧犯罪', heat: '热度 8400', trend: 'up' },
  { rank: 5, title: '大奉打更人', type: '国产喜剧', heat: '热度 8100', trend: 'new' },
];

export default function RankingSection() {
  const getRankColor = (rank: number) => {
    if (rank === 1) return 'text-accent-500';
    if (rank === 2) return 'text-accent-400';
    if (rank === 3) return 'text-accent-300';
    return 'text-foreground-400';
  };

  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return 'ri-arrow-up-line text-primary-500';
    if (trend === 'new') return 'ri-star-line text-accent-500';
    return 'ri-subtract-line text-foreground-400';
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            热播排行
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            全网热度最高的电视剧实时排名，看看大家都在追什么
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 md:p-5 border-b border-background-200/70 last:border-none cursor-pointer hover:bg-background-100 transition-colors rounded-lg group"
            >
              <span className={`text-2xl md:text-3xl font-heading font-bold w-10 text-center flex-shrink-0 ${getRankColor(item.rank)}`}>
                {item.rank}
              </span>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500">{item.type}</span>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs md:text-sm font-medium text-foreground-700">{item.heat}</span>
                <i className={`${getTrendIcon(item.trend)} text-sm`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}